import { OrdersDataGrid } from "./Orders";
import Grid from '@mui/material/Unstable_Grid2';
import { TextField, Typography, Slide, Button, Box, CircularProgress, Divider, Tabs, Tab, TabPanel } from '@mui/material';
import React, { Component, useState, useMemo } from "react";

export default function Production() {
    const [tabValue, setTabValue] = useState(0);
    function TabPanel(props) {
        return props.index == props.value && <Grid xs item >
            {props.children}
        </Grid>;
    }

    return <React.Fragment>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} >
            <Tabs value={tabValue} onChange={(e, value) => setTabValue(value)} centered variant="fullWidth">
                <Tab label="W relizacji" xs />
                <Tab label="Pliki poprawne" xs />
            </Tabs>
        </Box>
        <TabPanel value={tabValue} index={0}>
            <OrdersDataGrid
                style={{ height: "80vh" }}
                filterData={{
                    field: "products.status",
                    operator: "equals",
                    value: 3,
                }}
                sortmodel={{
                    field: "transport.completion_date",
                    sort: "asc"
                }} />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
            <OrdersDataGrid
                style={{ height: "80vh" }}
                filterData={{
                    field: "products.status",
                    operator: "equals",
                    value: 1,
                }}
                sortmodel={{
                    field: "transport.completion_date",
                    sort: "asc"
                }} />
        </TabPanel>
    </React.Fragment>
}